import { z } from 'zod';

export const NotificationQuerySchema = z.object({
  unread_only: z
    .union([z.boolean(), z.string()])
    .optional()
    .transform((v) => v === true || v === 'true'),
  limit: z.coerce.number().int().positive().max(100).default(30),
});

export type NotificationQuery = z.infer<typeof NotificationQuerySchema>;
